import React, {Component} from 'react';
import {Scrollbars} from "react-custom-scrollbars";
import {Icon} from 'antd'
import {uuid} from "../../../utils";
import $ from "jquery";

const BOTTOM_HEIGHT = 15;
class SimpleFloatTool extends Component {

    static defaultProps={
        width: 300,
        title: "浮动工具",
        top: 140,
        left: 10,
        itemPaddingRight: 30,
        showClose: true,
        visible: true,
        onMinus:()=>{},
        onClose:()=>{}
    };

    state={
        visible: this.props.visible,
        minus: this.props.minus,
        dragIng: false,
        top: this.props.top,
        left: this.props.left
    };

    innerLeft = 0;
    innerTop = 0;

    onDragStart=(e)=>{
        this.innerLeft = e.clientX - this.state.left;
        this.innerTop = e.clientY - this.state.top;
    };

    onDragEnd = (e)=>{
        if(e.clientX > 0){
            this.state.left = e.clientX - this.innerLeft;
        }
        if(e.clientY > 0){
            this.state.top = e.clientY - this.innerTop;
        }
        this.checkPosition();
    };

    /**
     * 检查位置，不能出这个边框
     */
    checkPosition() {
        if (this.state.left <= 0) {
            this.state.left = 0;
        }
        if ((this.state.left + $(`#${this.id}`).outerWidth()) >= document.body.clientWidth) {
            this.state.left = document.body.clientWidth - $(`#${this.id}`).outerWidth();
        }

        if (this.state.top <= 0) {
            this.state.top = 0;
        }
        if ((this.state.top + $(`#${this.id}`).outerHeight()) >= document.body.clientHeight) {
            this.state.top = document.body.clientHeight - $(`#${this.id}`).outerHeight();
        }
        this.setState({});
    }

    setMinus = (minus) => {
        this.setState({
            minus
        }, () => {
            this.checkPosition();
        });
        this.props.onMinus(!this.state.minus);
    };

    onDrag=(e)=>{
        this.onDragEnd(e);
    };

    id=uuid();

    show() {
        this.setState({visible:true})
    }

    hide() {
        this.setState({visible:false})
    }

    renderContent = () => {
        return (
            <>
                <tr>
                    <td colSpan={2}
                        style={{borderTop: "1px solid #ccc", padding: `15px 15px ${BOTTOM_HEIGHT}px 15px`}}>
                        <Scrollbars
                            autoHeight={true}
                            autoHeightMax={document.body.clientHeight - 300}
                        >
                            {React.Children.map(this.props.children, item => {
                                return <div style={{paddingRight: this.props.itemPaddingRight}}>{item}</div>;
                            })}
                        </Scrollbars>
                    </td>
                </tr>
                {
                    this.props.footer ? <tr>
                        <td colSpan={2} align={this.props.bottomAlign ? this.props.bottomAlign : "left"}
                            style={{
                                borderTop: "1px solid #ccc",
                                padding: `15px 15px 0px 15px`
                            }}>{this.props.footer}</td>
                    </tr> : null
                }
            </>
        )
    };
    moveContentToDrawer = () => {
        let that = this;
        if(typeof window.ueditor?.onPushEditorLeftDrawer === "function") {
            window.ueditor.onPushEditorLeftDrawer([{
                key: "geegqw",
                name: "敏感词检测",
                title: that.props.title,
                component: that.props.children,
                footer: that.props.footer
            }])
        }
    };
    renderHeader = () => {
        return (
            <tr style={{cursor: "move"}} height={50} valign={"middle"}
                draggable={true}
                onDragStart={(e) => {
                    this.onDragStart(e);
                    $(`#${this.id}Mask`).show()
                }}
                onDrag={(e) => {
                    this.onDrag(e)
                }}
                // onDragOver={(e) => {
                //     e.preventDefault()
                // }}
                onDragEnd={(e) => {
                    this.onDragEnd(e);
                    e.preventDefault();
                    $(`#${this.id}Mask`).hide()
                }}>
                {this.props.title && <td style={{paddingLeft: 15}}>{this.props.title}</td>}
                <td align={"right"} style={{paddingRight: 15}}>
                    {/*<span onClick={this.moveContentToDrawer}>移出</span>*/}
                    {
                        this.state.minus ?
                            <Icon type="fullscreen"
                                  onClick={() => {
                                      this.setState({
                                          minus: !this.state.minus
                                      }, () => {
                                          this.checkPosition();
                                      });
                                      this.props.onMinus(!this.state.minus);
                                  }}
                            /> :
                            <Icon type="minus" onClick={() => {
                                this.setState({
                                    minus: !this.state.minus
                                }, () => {
                                    this.checkPosition();
                                });
                                this.props.onMinus(!this.state.minus);
                            }}/>
                    }
                    {this.props.showClose && <Icon type="close" style={{marginLeft: 10}} onClick={() => {
                        this.setState({visible: false});
                        this.props.onClose();
                    }}/>}
                </td>
            </tr>
        )
    };

    render() {
        if(!this.state.visible){
            return <div/>
        }
        return (
            <>
                <div id={this.id + "Mask"} style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 998,
                    display: "none",
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    opacity: 0
                }}></div>
                <div id={this.id} style={{
                    position: "fixed",
                    top: this.state.top,
                    left: this.state.left,
                    background: "#fff",
                    borderRadius: 5,
                    zIndex: 999,
                    boxShadow: "0px 0px 5px #d9d3d3",
                    padding: `0px 0px ${this.state.minus ? "0px" : "15px"} 0px`,
                    width: this.props.width
                }}
                >
                    <table cellPadding={0} cellSpacing={0} width={"100%"} border={0}>
                        <tbody>
                        {this.renderHeader()}
                        {!this.state.minus ? this.renderContent() : ""}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}

export default SimpleFloatTool;